import React from 'react'
import CheckoutProduct from './CheckoutProduct';
import './ShowMyTable.css'
import { useStateValue } from './StateProvider';
import Subtotal from './Subtotal'
import { Link } from "react-router-dom";

function ShowMyTable() {
    const [{ basket ,user }, dispatch] = useStateValue();

    return (
        <div className='showmytable'>
            <meta name="viewport" content="width=100%"/>
            <div className='checkout__left'>
                <h3 className="user__email">Hello, {user?.email}</h3>
                <h2 className='checkout__title'>Your Table</h2>

                {basket.map(item => (
                    <CheckoutProduct 
                        id = {item.id}
                        title = {item.title}
                        image = {item.image}
                        price = {item.price}
                    />
                ))}
                
                
                {/* BasketItem */}
                {/* BasketItem */}
                {/* BasketItem */}
                {/* BasketItem */}
                
            </div>
            <div className='checkout__right'>
                <Subtotal />
                <Link to='/orders'>
                    <button className='previous__orders'>Previous Orders</button>
                </Link>
            </div>
        </div>
    )
}

export default ShowMyTable
